import { Component, OnDestroy } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { MaintenanceStoreService } from '@lib-core/maintenance/services/maintenance-store.service';
import { LoaderService } from '@lib-shared/loader/services/loader.service';
import { FallbackService } from './services/fallback.service';

import { environment } from '@environments/environment';
import { LoaderTextComponent } from '../../lib-shared/loader/components/loader-text/loader-text.component';
import { AsyncPipe } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
  selector: 'app-fallback',
  templateUrl: './fallback.component.html',
  styleUrls: ['./fallback.component.scss'],
  standalone: true,
  imports: [MatCard, MatCardContent, LoaderTextComponent, AsyncPipe],
})
export class FallbackComponent implements OnDestroy {
  phone = environment.core.phone.reception;

  isMaintenanceActive$ = this.getMaintenanceStream$();
  isMaintenanceChecking = false;

  /**
   * constructor
   *
   */
  constructor(
    private fallbackService: FallbackService,
    private maintenanceStoreService: MaintenanceStoreService,
    private loaderService: LoaderService,
  ) {}

  /**
   * ngOnDestroy
   *
   */
  ngOnDestroy(): void {
    this.fallbackService.deactivate();
  }

  /**
   * onReload
   *
   */
  onReload(): void {
    this.loaderService.open();
    window.location.reload();
  }

  /**
   * getMaintenanceStream
   *
   */
  private getMaintenanceStream$(): Observable<boolean> {
    this.isMaintenanceChecking = true;

    return this.maintenanceStoreService
      .getIsActiveMixed$()
      .pipe(tap(() => (this.isMaintenanceChecking = false)));
  }
}
